import { forwardRef, useState, type InputHTMLAttributes } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { Input, type InputProps } from './Input';

export interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  showLockIcon?: boolean;
  error?: InputProps['error'];
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showLockIcon = true, ...rest }, ref) => {
    const [visible, setVisible] = useState(false);
    return (
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        autoComplete={rest.autoComplete ?? 'current-password'}
        leftIcon={showLockIcon ? <Lock className="h-4 w-4" /> : undefined}
        rightIcon={
          <button
            type="button"
            onClick={() => setVisible((v) => !v)}
            className="pointer-events-auto text-fg-muted hover:text-fg transition-colors"
            aria-label={visible ? 'Hide password' : 'Show password'}
            tabIndex={-1}
          >
            {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        }
        {...rest}
      />
    );
  },
);
PasswordInput.displayName = 'PasswordInput';
